import { createMembershipInquiryPreviewResponse } from '@/pages/orders/_components/membership-review-inquiry-mock';
import type { MarketStoreListItem } from '@/pages/orders/_consts/constants';
import type { InquiryItem } from '@/types/api';
import { Inquiry, InquiryInitial } from '@/types/inquiry';

export type MobileInquiryPreviewStore = MarketStoreListItem & {
  HasInquiry: boolean;
  HasFurtherAction: boolean;
  IsReleasedStatus: boolean;
};

export const normalizePreviewInquiry = (
  inquiry: InquiryItem,
  storeList: Array<MobileInquiryPreviewStore>,
): Inquiry => {
  const matchedStore = storeList.find((store) => store.StoreId === inquiry.StoreId);

  return {
    ...InquiryInitial,
    ...inquiry,
    MarketName: matchedStore?.MarketName ?? '',
    AttachmentsList: [],
    CheckeDate: '',
    WriterName: '',
    ProductItemNo: inquiry.ProductItemNo ?? '',
    InquiryType: inquiry.InquiryType ?? inquiry.QnaTypeCode,
    InquiryCommentList: inquiry.InquiryCommentList ?? [],
    CoupangWingId: inquiry.CoupangWingId ?? '',
    EsmToken: inquiry.EsmToken ?? '',
  };
};

export const createMobileInquiryPreviewData = () => {
  const { StoreList, InquiryList } = createMembershipInquiryPreviewResponse().data[0];

  const previewStoreList: Array<MobileInquiryPreviewStore> = StoreList.map((store) => ({
    ...store,
    HasInquiry: store.StoreId === 'sellerbox-store',
    HasFurtherAction: false,
    IsReleasedStatus: false,
  }));

  const previewInquiryList = InquiryList.map((inquiry) =>
    normalizePreviewInquiry(inquiry, previewStoreList),
  );

  return {
    StoreList: previewStoreList,
    InquiryList: previewInquiryList,
  };
};

export const findMobileInquiryPreview = (inquiryNo: string): Inquiry => {
  const { InquiryList } = createMobileInquiryPreviewData();

  return (
    InquiryList.find((inquiry) => inquiry.InquiryNo === inquiryNo) ??
    InquiryList[0] ??
    InquiryInitial
  );
};
